const VIEW_MODE = {
  SITE: 'SITE',
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW',
  SEO: 'SEO',
} as const;

export default VIEW_MODE;
